import React from "react";
import { Navigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

const AuthWrapper = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  // If MSAL is still initializing but we already have accounts, set one
  if (!instance.getActiveAccount() && instance.getAllAccounts().length > 0) {
    instance.setActiveAccount(instance.getAllAccounts()[0]);
  }

  // Still waiting for MSAL to confirm authentication → show nothing (or loader)
  if (!isAuthenticated && instance.getAllAccounts().length > 0) {
    return null; // or a CircularProgress spinner if you prefer
  }

  // If user not authenticated → send to signin
  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  return <>{children}</>;
};

export default AuthWrapper;